<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap pb-5>
                        <v-flex xs12 pb-5>
                            <a href="/egarant-companies">Список компаний</a>
                        </v-flex>
                        <v-flex xs12>
                            <h1>Настройки компании {{ name }}</h1>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex v-if="integrated" xs12 sm6 md3 lg2>
                            <v-checkbox
                                label="Компания активна"
                                v-model="active"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2>
                            <v-checkbox
                                label="Случайный порядок"
                                v-model="shuffle"
                            />
                        </v-flex>
                        <v-flex v-if="integrated" xs12 sm6 md3 lg2>
                            <v-text-field
                                v-model.number="dailyLimit"
                                label="Дневной лимит ссылок"
                                :min="0"
                                type="number"
                                validate-on-blur
                                required
                                :rules="[rules.required, rules.integer]"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <draggable
                            :list="companies"
                            tag="ul"
                            v-bind="dragOptions"
                            :dataIdAttr="'priority'"
                            :sort="true"
                            @start="drag=true"
                            @end="drag=false"
                        >
                            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                <li
                                    class="list-group-item"
                                    v-for="element in companies"
                                    :key="element.id"
                                >
                                    {{ element.name }}
                                </li>
                            </transition-group>
                        </draggable>
                    </v-layout>
                    <v-layout row pt-4>
                        <v-btn @click="save"
                               class="submit-button block">Сохранить
                        </v-btn>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
import draggable from 'vuedraggable'

export default {
    components: {
        draggable
    },
    name: "EgarantCompanySettings",
    props: ['name', 'active', 'shuffle', 'integrated', 'dailyLimit', 'queryOrder'],
    data: () => ({
        companies: [],
        rules: {
            required: v => typeof v === 'number' || 'Обязательное поле',
            integer: v => Number.isInteger(Number(v)) || 'Допускаются только целые числа'
        }
    }),
    created() {
        this.companies = JSON.parse(atob(this.queryOrder));
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },
    methods: {
        save: function() {
            if (!this.validate()) {
                return;
            }

            for(let i = 0; i < this.companies.length; i++) {
                this.companies[i].priority = i;
            }
            let formData = {
                'settings': {
                    'active': this.active,
                    'shuffle': this.shuffle,
                    'limit': this.dailyLimit
                },
                'companies': this.companies
            };
            axios.patch(location.href, formData)
                .then(response => {
                    PNotify.success('Настройки сохранены.');
                }).catch(error => {
                PNotify.error('При сохранении настроек возникла ошибка.');
                console.log(error);
            });
        },
        validate: function () {
            if (!this.$refs.form.validate()) {
                this.$nextTick(function () {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
                return false;
            }
            return true;
        }
    }
}
</script>

<style scoped>
    /deep/ h1 {
        font-size: 48px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;
    }

    /deep/ h2, h3, h4 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }

    /deep/ h4 {
        font-size: 16px;
    }

    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 56px;
        background-color: #00ba57 !important;;
        text-align: center;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0 5px;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    .submit-button >>> .v-btn__content {
        white-space: pre-wrap;
        padding: 16px 60px 0;
        line-height: 1.1;
    }

    .list-group-item:first-child {
        border-top-left-radius: .25rem;
        border-top-right-radius: .25rem;
    }

    .list-group-item {
        position: relative;
        display: block;
        padding: .75rem 1.25rem;
        margin-bottom: -1px;
        background-color: #fff;
        border: 1px solid rgba(0,0,0,.125);
    }

    .list-group-item {
        cursor: move;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }

    .no-move {
        transition: transform 0s;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/egarant-companies/EgarantCompanySettings.vue